
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Paginator',
  props: {
    showNext: {
      type: Boolean,
      default: true
    },
    showPrevious: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleNext() {
      this.$emit('next')
    },
    handlePrevious() {
      this.$emit('previous')
    }
  }
})
